import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// Last-resort safety net: surface any unhandled promise rejection so React
// doesn't silently die in concurrent mode. The ErrorBoundary catches render
// errors; this catches async ones.
window.addEventListener('unhandledrejection', (event) => {
  // eslint-disable-next-line no-console
  console.error('[WAYO] Unhandled promise rejection:', event.reason);
});

// Register the service worker for PWA support (offline, installable)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => {
        // When a new SW finishes installing (and there's already a controller,
        // i.e. this isn't first install), tell it to activate immediately.
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
        // eslint-disable-next-line no-console
        console.log('Service Worker registered:', reg.scope);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error('Service Worker registration failed:', err);
      });

    // Reload exactly ONCE per tab session when a NEW SW takes over an already-
    // controlled page (i.e. a real update, not the first install). On a fresh
    // visit `navigator.serviceWorker.controller` is null until the newly-
    // registered SW calls `clients.claim()` — reloading in that case would
    // just replay the splash for no reason. Snapshot the controller at page
    // load and skip the reload if there wasn't one.
    const hadControllerAtLoad = !!navigator.serviceWorker.controller;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!hadControllerAtLoad) return; // fresh install → no reload needed
      try {
        if (sessionStorage.getItem('sw-reloaded') === '1') return;
        sessionStorage.setItem('sw-reloaded', '1');
      } catch (_) {
        // sessionStorage blocked (private mode, etc.) — skip the reload entirely
        return;
      }
      window.location.reload();
    });
  });
}
